import { render, staticRenderFns } from "./addHszn3.vue?vue&type=template&id=531854a0&scoped=true"
import script from "./addHszn3.vue?vue&type=script&lang=js"
export * from "./addHszn3.vue?vue&type=script&lang=js"
import style0 from "./addHszn3.vue?vue&type=style&index=0&id=531854a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531854a0",
  null
  
)

export default component.exports